'use client';

import { faClock } from '@fortawesome/free-solid-svg-icons';
import Link from 'next/link';
import type React from 'react';
import { useState } from 'react';
import FaIcon from '../../../../components/icon/FaIcon/FaIcon';
import CarouselModal from '../../../../components/ui/CarouselModal/CarouselModal';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { VariantType } from '../../../../types';
import { scrollIntoTheView } from '../../../../utils';
import type { WChanceEventItem } from '../../types';
import WChanceCardHeader from '../WChanceCardHeader/WChanceCardHeader';
import styles from './WChanceIsSessionCard.module.scss';

export interface WChanceIsSessionCardProps {
  wChanceEvent: WChanceEventItem;
  hasMultiLabel?: boolean;
  variant?: VariantType;
  listSectionId: string;
  formatDateCommon: (date: string, format: string) => string;
  Format: { dateTimeLotteryJa: string };
}

function WChanceIsSessionCard({
  wChanceEvent,
  hasMultiLabel = false,
  variant = 'default',
  listSectionId,
  formatDateCommon,
  Format,
}: WChanceIsSessionCardProps) {
  const [isScrollModalOpen, setIsScrollModalOpen] = useState(false);

  const openEventModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsScrollModalOpen(true);
  };

  const scrollToList = (e: React.MouseEvent) => {
    e.preventDefault();
    scrollIntoTheView(listSectionId);
  };

  return (
    <div className={styles.componentStyle}>
      <WChanceCardHeader variant={variant} />
      <div className={styles.hr} />
      <div key={wChanceEvent.id}>
        <p className={`${utilsStyles.mtXSmall} ${utilsStyles.textSmall}`}>
          Wチャンス賞は対象の期間内にくじを引いた方のみ応募できます。
          <br />
          期間が異なるWチャンス賞への応募はできません。
        </p>
        <div className={styles.statusWrapper}>
          {hasMultiLabel ? (
            <div className={styles.orderText}>第{wChanceEvent.sort}弾</div>
          ) : (
            // 表示調整用のダミー要素
            <div />
          )}
          <div className={styles.statusLabel} style={statusLabelStyle('primary')}>
            開催中
          </div>
        </div>
        <div className={`${styles.dateWrapper} ${utilsStyles.textBold}`}>
          <div className={styles.dateIcon}>
            <FaIcon icon={faClock} />
          </div>
          <span>
            &nbsp;
            {formatDateCommon(wChanceEvent.startAt, Format.dateTimeLotteryJa)}
            &nbsp;~&nbsp;
            {formatDateCommon(wChanceEvent.endAt, Format.dateTimeLotteryJa)}
          </span>
        </div>
        <div className={styles.title}>{wChanceEvent.name}</div>
        <div className={styles.detailArea}>
          <div className={styles.thumbnail}>
            {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
            <a onClick={openEventModal}>
              <ImageView src={wChanceEvent.imageUrl} />
            </a>
          </div>
          <p className={styles.labelDescription}>{wChanceEvent.description}</p>
        </div>
        <div className={utilsStyles.mtXSmall}>
          <Link href={'#'} onClick={scrollToList} className={`${utilsStyles.textLink} ${utilsStyles.textSmall}`}>
            Wチャンス賞一覧はコチラ
          </Link>
        </div>
      </div>
      <CarouselModal
        initShowIndex={0}
        isOpen={isScrollModalOpen}
        close={() => setIsScrollModalOpen(false)}
        childrenArr={[
          <div className={styles.goodsModal} key={wChanceEvent.id}>
            <ImageView src={wChanceEvent.imageUrl} alt={'Wチャンス景品'} isFreeSize />
            <div className={styles.modalPadding}>
              <div className={styles.marginTop}>
                <em>{wChanceEvent.name}</em>
              </div>
            </div>
          </div>,
        ]}
      />
    </div>
  );
}

function statusLabelStyle(color: string) {
  return {
    backgroundColor: `var(--color-${color})`,
  };
}

export default WChanceIsSessionCard;
